import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import Store, { persistor } from './Redux/Store';
import { PersistGate } from 'redux-persist/integration/react';
import { PostHogProvider } from 'posthog-js/react';
import posthog from 'posthog-js';

try {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com',
    capture_pageview: true,
    session_recording: {
      maskAllInputs: false,
    },
  });
  posthog.opt_in_capturing();
  // console.log(posthog.get_session_replay_url({ withTimestamp: true }));

  // console.log("PostHog Initialized:", process.env.REACT_APP_PUBLIC_POSTHOG_KEY, process.env.REACT_APP_PUBLIC_POSTHOG_HOST);
} catch (error) {
  console.error("Posthog Error",error);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    args[0].includes("ResizeObserver loop completed with undelivered notifications")
  ) {
    return;
  }
  originalError(...args);
};

root.render(
  <PostHogProvider client={posthog}> {/* ✅ use client prop, not apiKey+options */}
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </PostHogProvider>
);

reportWebVitals();
